import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ImageLoader from '../image-loader';
import styles from './profile-photo.scss';

const getStyle = src => ({
  backgroundImage: src && `url(${src})`,
});

const renderOverlay = isLoading => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <ImageLoader type="mini"/>
    </div>
  );
};

const ProfilePhoto = ({ src, isLoading }) =>
  <div
    className={classNames(styles.photo, 'profile-photo-border-color')}
    style={getStyle(src)}
    data-hook="profile-photo"
  >
    {renderOverlay(isLoading)}
  </div>;

ProfilePhoto.propTypes = {
  src: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ProfilePhoto;



// WEBPACK FOOTER //
// ./app/components/profile-photo/profile-photo.js